<div class="grid" style="overflow-y : auto;">
    <div *ngIf="allowCreate" class="col-12" style="text-align: left">
        <a [routerLink]="[detailUrl + '0']"><p-button class="mr-1" icon="fas fa-plus-circle" label="Neu"></p-button></a>
        <ng-container *ngTemplateOutlet="toolbarTemplate"></ng-container>
    </div>
    <sm-table class="compact col-12" [data]="data" [allowDelete]="allowDelete" [gridLines]="gridLines" (onRowSelect)="rowSelect($event)" (onDelete)="deleteRow($event)"></sm-table>
</div>
